// import withRecordForm from './withRecordForm';
// export default withRecordForm;

export { withRecordForm } from './withRecordForm';
